export default __webpack_public_path__ + "static/timberline-28-DISK-SCRUBBER-aviation-ecdfd3888bb2951df89c8258fee2c8b1.jpg";